"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryProxy = void 0;

var _common = require("./../common");

var _service = require("./../service");

class BasisTheoryProxy extends _service.BasisTheoryService {
  get(options) {
    return this.proxyRequest('get', options);
  }

  post(options) {
    return this.proxyRequest('post', options);
  }

  put(options) {
    return this.proxyRequest('put', options);
  }

  patch(options) {
    return this.proxyRequest('patch', options);
  }

  delete(options) {
    return this.proxyRequest('delete', options);
  }

  proxyRequest(method, options) {
    var _options$path2;

    if (method === 'post' || method === 'put' || method === 'patch') {
      var _options$path, _options$body;

      const extractor = options !== null && options !== void 0 && options.includeResponseHeaders && method === 'post' ? _common.dataAndHeadersExtractor : _common.dataExtractor;
      return this.client[method]((_options$path = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path !== void 0 ? _options$path : '', (_options$body = options === null || options === void 0 ? void 0 : options.body) !== null && _options$body !== void 0 ? _options$body : undefined, (0, _common.createRequestConfig)(options, {
        transformRequest: _common.proxyRaw,
        transformResponse: _common.proxyRaw
      })).then(extractor);
    }

    return this.client[method]((_options$path2 = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path2 !== void 0 ? _options$path2 : '/', (0, _common.createRequestConfig)(options, {
      transformRequest: _common.proxyRaw,
      transformResponse: _common.proxyRaw
    })).then(_common.dataExtractor);
  }

}

exports.BasisTheoryProxy = BasisTheoryProxy;